// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4928 ? "e18fe737" : chunkId) + "." + {"4928":"0c7a0b48821297a2","7141":"2f5a5cc4cb1678d2","7896":"20b0f8844499f6d5"}[chunkId] + ".js";
};